import React from "react";
import toast from "react-hot-toast";
import useApi from "../useApi";
import { IUsersRes } from "./index.type";

interface UseGetAllUsersProps {
  pageNumber: number;
  perpageData: number;
  selectedClinic?: string;
  selectedRole?: string;
  excludedRoles?:string[]
}

const useGetAllUsers = ({
  pageNumber,
  perpageData,
  selectedClinic,
  selectedRole,
  excludedRoles
}: UseGetAllUsersProps) => {
  const [usersData, setUsersData] = React.useState<IUsersRes>();

  const params = new URLSearchParams({
    page: String(pageNumber),
    limit: String(perpageData),
    ...(selectedClinic && { clinic: selectedClinic }),
    ...(selectedRole && { role: selectedRole }),
    ...(excludedRoles && { excludedRoles: excludedRoles.join(",") }),
  });

  const { loading: usersDataLoading, makeApiCall } = useApi({
    url: `/users?${params.toString()}`,
    method: "GET",
  });

  const getUsersData = async () => {
    const { response, error } = await makeApiCall<undefined, IUsersRes>();

    if (response?.status === "success") {
      setUsersData(response);
    } else {
      setUsersData(undefined);
    }

    if (error) {
      toast.error(
        "Something went wrong while fetching users data. Please try again later."
      );
    }
  };

  React.useEffect(() => {
    getUsersData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageNumber, selectedClinic, selectedRole]);

  return { usersData, getUsersData, usersDataLoading };
};

export default useGetAllUsers;
